import { booleanField, hiddenField, optionField, stringField } from 'common/utils/form/fieldTypes';

const config = {
  id: hiddenField(),
  store_group: optionField({ required: true }),
  description: stringField({ required: true }),
  code: stringField({ required: true }),
  purchasing_unit_id: optionField(),
  color_name: stringField(),
  color_hex_code: stringField(),
  ihm_related: booleanField({ initialValue: false }),
  photo: stringField()
};

export default config;
